<template lang="pug">
div
  v-layout.flex-column-phone(align-center, justify-space-between)
    h2 Websiteprofielen

    v-layout.grow-0(align-center)
      v-text-field(
        v-model='search',
        append-icon='fa fa-search',
        label='Zoeken',
        hide-details,
        clearable,
        solo,
        style='max-width: 250px'
        )
      v-btn.ml-4.hidden-phone(color='primary', :to='{ name: "website details", params: { websiteId: "new" } }') Nieuw websiteprofiel

  v-tabs.mt-3(v-model='activeTab', slider-color='primary')
    v-tab.mr-4(key='all', :to='{ name: "all websites" }') Alle websiteprofielen
    v-tab.mr-4(key='private', :to='{ name: "private lease websites" }') Krediet websiteprofielen
    v-tab(key='business', :to='{ name: "business lease websites" }') Financial Lease websiteprofielen

  router-view
</template>

<script>
export default {
  data () {
    return {
      activeTab: 'all',

      search: this.$store.state.filters.search
    }
  },

  watch: {
    search (v) {
      this.$store.commit('filters/setSearch', v)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
